/** @format */

import {useState, MouseEvent} from 'react';

import {Box, ClickAwayListener, Popover, Typography} from '@mui/material';

import {Check} from '@mui/icons-material';

import {Space} from 'pages/Home/DigitalCast/models/spaces';

import {WidgetBlock} from 'pages/Home/DigitalCast/models/widgets';

import {
  WorkspaceRoot as Root,
  workspaceClasses as classes,
  SettingsButton,
  StyledTextField,
} from './style';
import Dropdown from '../../dropdown';
import useTitle from './hooks/useTitle';
import {HintTooltip} from './components/HintTooltip';

interface Props {
  space: Space;
  widgetBlocks: WidgetBlock[];
  onChangeTitle: (value: string) => void;
  onConfirmMenuSettings: (space: Space) => void;
  onRemoveSpace: () => void;
}

const WidgetWorkspace = ({
  space,
  onChangeTitle,
  onConfirmMenuSettings,
  widgetBlocks,
  onRemoveSpace,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const {title, id} = space;
  const settingsImg = new URL('../../../images/settings.svg', import.meta.url).href;

  const {edit, innerValue, onStartEditTitle, onStopEditTitle, onChangeInnerValue} = useTitle(
    title,
    onChangeTitle,
  );

  const handleSettingsClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  const handleConfirmMenuSettings = (space: Space) => {
    handleSettingsClose();
    onConfirmMenuSettings(space);
  };

  const handleClickAway = () => {
    if (edit) {
      onStopEditTitle();
    }
  };

  const open = Boolean(anchorEl);
  const elementId = open ? id : undefined;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Root>
        <Box className={classes.titleColumn}>
          {edit ? (
            <HintTooltip open={edit}>
              <StyledTextField
                value={innerValue}
                onBlur={onStopEditTitle}
                onChange={onChangeInnerValue}
              />
            </HintTooltip>
          ) : (
            <Box className={classes.titleBox}>
              <Typography className={classes.titleText} onClick={onStartEditTitle}>
                {title}
              </Typography>
            </Box>
          )}
        </Box>

        {edit ? (
          <SettingsButton onClick={onStopEditTitle} open={open}>
            <Check />
          </SettingsButton>
        ) : (
          <SettingsButton onClick={handleSettingsClick} aria-describedby={elementId} open={open}>
            <img src={settingsImg} alt='настройки' />
          </SettingsButton>
        )}

        <Popover
          id={elementId}
          open={open}
          onClose={handleSettingsClose}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            marginLeft: '4px',
          }}
          slotProps={{
            paper: {
              sx: {
                background: 'none',
                borderRadius: '8px',
              },
            },
          }}
        >
          <Dropdown
            onCloseDropdown={handleSettingsClose}
            onConfirmMenuSettings={handleConfirmMenuSettings}
            onRemoveSpace={onRemoveSpace}
            space={space}
            widgetBlocks={widgetBlocks}
          />
        </Popover>
      </Root>
    </ClickAwayListener>
  );
};

export {WidgetWorkspace};
